import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAds } from '@app/utils/utils';
import { CreateAdWizardModal } from '@app/Ads/CreateAdWizardModal';

// Full-window route (/ads/new) that hosts the Create Ad wizard in page mode.
// Reads an optional ?type=upload|ai to preselect the ad type and fetches the
// existing ads so the wizard can generate a unique default name.
const CreateAdPage: React.FunctionComponent = () => {
    const [searchParams] = useSearchParams();
    const [existingAds, setExistingAds] = useState<any[] | null>(null);

    const typeParam = searchParams.get('type');
    const initialAdType = typeParam === 'ai' || typeParam === 'upload' ? typeParam : undefined;

    useEffect(() => {
        getAds()
            .then((result) => setExistingAds(result || []))
            .catch(() => setExistingAds([]));
    }, []);

    // Wait for the ad list before mounting the wizard: it generates its unique
    // default name (e.g. "My Ad 2") once on mount from existingAds, and the
    // backend enforces a unique name per organization. Mounting before the list
    // loads would always propose "My Ad 1" and 500 on the second creation.
    if (existingAds === null) {
        return null;
    }

    return (
        <CreateAdWizardModal
            displayMode="page"
            hideButton
            triggerRefresh={() => { /* list refetches when /ads remounts */ }}
            existingAds={existingAds}
            initialAdType={initialAdType}
        />
    );
};

export { CreateAdPage };
